/**
 * Class constants for the tooltip surface.
 *
 * A tooltip must survive a pointer leaving the trigger and travelling across
 * the tooltip itself, so the popup is not pointer-events-none: the primitive
 * keeps it open while hovered.
 */

export const tooltipStyles = {
  trigger: 'inline-flex',

  /**
   * The positioning layer.
   *
   * THE Z-INDEX HAS TO LIVE HERE, NOT ON THE POPUP.
   *
   * The Positioner is `position: absolute` with `will-change: transform`, which
   * makes it a stacking context. A `z-index` on the Popup is scoped to that
   * context, so it cannot lift the tooltip above anything outside it — measured
   * losing to a sticky table cell's `z-10`, which put the tooltip behind the
   * pinned column it was describing.
   *
   * `z-50` on the Positioner lifts the whole portal layer instead. The tooltip
   * is portaled to `<body>`, so it competes with the page's own stacking
   * contexts, and the sticky cells in a data table are the tallest thing it has
   * to clear.
   */
  positioner: 'z-50',

  popup:
    'max-w-xs rounded-control border border-border-strong bg-surface-raised px-2 py-1 text-xs text-content shadow-md transition-opacity duration-100 data-[starting-style]:opacity-0 data-[ending-style]:opacity-0',

  arrow: 'block fill-surface-raised stroke-border-strong',
} as const;